import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export enum InputStyle {
  Primary = 'Primary',
}

export enum InputHeight {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
}

interface ITextInputProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  className?: string;
  inputHeight?: InputHeight;
  inputStyle: InputStyle;
  label?: string;
  iconLeft?: any;
  innerRef?: any;
}

export default function Input({
  className,
  inputStyle,
  inputHeight,
  label,
  iconLeft,
  innerRef,
  ...props
}: ITextInputProps) {
  const classes = twMerge(
    clsx('bg-translucent placeholder-primary text-primary focus:outline-none focus:ring-b-2 focus:ring-2 focus:border-white focus:ring-white px-4 w-full leading-tight',
      {
        'py-6 text-title-2': inputHeight === InputHeight.Large,
        'py-5 text-headline': inputHeight === InputHeight.Medium,
        'py-1 text-md': inputHeight === InputHeight.Small,
        'rounded-lg': inputStyle === InputStyle.Primary,
        'pt-8 pb-2': !!label && inputHeight === InputHeight.Medium,
        'pl-16': !!iconLeft,
      }
    ),
    className
  );

  return (
    <div className="relative">
      {iconLeft && <div className="absolute text-primary flex items-center pl-6">{iconLeft}</div>}
      {label && <p className="absolute text-primary text-xs pt-3 pl-4 uppercase">{label}</p>}
      <input {...props} ref={innerRef} className={classes} />
    </div>
  );
}
